import { Paper } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as css from './BlankPage.css'

const BlankPage: React.FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <div className={css.wrapper}>
      <Paper className={css.container}>
        <div style={{ marginBottom: 4 }}>
          <Typography variant='h3'>
            {t('bb.common.label.comingSoon', 'Coming Soon')}
          </Typography>
        </div>
        <div>
          <Typography variant='subtitle1' color='textSecondary'>
            {t('bb.common.label.underDevelopment', 'This page is under development')}
          </Typography>
        </div>
      </Paper>
    </div>
  )
}

export { BlankPage }
